import React, { Component } from "react";
import AirbnbFeed from './Networks/AirbnbFeed';
import FlickrFeed from "./Networks/FlickrFeed";
import PinterestFeed from "./Networks/PinterestFeed";
import RssFeed from "./Networks/RssFeed";
import WorkspaceFeed from "./Networks/WorkspaceFeed";
import LinkedInFeed from "./Networks/LinkedInFeed";
import YelpFeed from "./Networks/YelpFeed";
import YoutubeFeed from "./Networks/YoutubeFeed";
import TwitterFeed from "./Networks/TwitterFeed";
import VimeoFeed from "./Networks/VimeoFeed";
import TiktokFeed from "./Networks/TiktokFeed";
import GoogleFeed from "./Networks/GoogleFeed";
import SlackFeed from "./Networks/SlackFeed";
import FbFeed from "./Networks/FbFeed";
import InstaFeed from "./Networks/InstaFeed";
import BlueskyFeed from "./Networks/BlueskyFeed";
import ThreadFeed from "./Networks/ThreadFeed";

class AddFeed extends Component {
    render() {
        const { selectedNetworkId } = this.props;
        switch (selectedNetworkId) {
            case 1:
                return <TwitterFeed {...this.props} />
            case 3:
                return <FbFeed {...this.props} />
            case 4:
                return <GoogleFeed {...this.props} />
            case 5:
                return <PinterestFeed {...this.props} />
            case 6:
                return <FlickrFeed {...this.props} />
            case 7:
                return <YoutubeFeed {...this.props} />
            case 8:
                return <VimeoFeed {...this.props} />
            case 10:
                return <LinkedInFeed {...this.props} />
            case 12:
                return <RssFeed {...this.props} />
            case 15:
                return <WorkspaceFeed {...this.props} />
            case 18:
                return <InstaFeed {...this.props} />
            case 19:
                return <YelpFeed {...this.props} />
            case 20:
                return <SlackFeed {...this.props} />;
            case 23:
                return <AirbnbFeed {...this.props} />
            case 28:
                return <TiktokFeed {...this.props} />
            case 31:
                return <BlueskyFeed {...this.props} />
            case 32:
                return <ThreadFeed {...this.props} />

            default:
                return <></>
        }
    }
}

export default AddFeed;